import {useMutation} from '@tanstack/react-query';
import {type} from 'arktype';
import {AccountId} from '~/entities/operations-fiat';
import {expectEither, HttpClient, POST, ServerValidationResult, useHttpClient} from '~/library/network-facade';

type FinishTopupBankParams = {
    amount: string;
    payment_network: number;
    bank_id: number;
};

function finishTopupBank(http: HttpClient, accountId: AccountId, params: FinishTopupBankParams) {
    return http(`v1/accounts/${accountId}/receive/banks`, POST(params)).then(
        ...expectEither({
            204: null,
            400: ServerValidationResult.to(
                type({
                    amount: 'string',
                    payment_network: 'string',
                    bank_id: 'string',
                })
            ),
        })
    );
}

export function useFinishTopupBank(accountId: AccountId) {
    const http = useHttpClient();
    return useMutation({
        mutationKey: ['v1/accounts/{accountId}/receive/banks', accountId],
        mutationFn: async (params: FinishTopupBankParams) => {
            const res = await finishTopupBank(http, accountId, params);
            switch (res.status) {
                case 204:
                    return {ok: true} as const;
                case 400:
                    return {ok: false, issues: res.json} as const;
                case 'Abort':
                    return {ok: false, issues: {}} as const;
            }
        },
    });
}
